export default {
    install:(Vue)=>{
        /**
         * 对时间戳转化为形如2021-04-07 11:21:12
         * timestamp:对时间戳的偏移
         *
        */
        Vue.filter('timeToDate',function(data,timestamp=0){
            let date=format(data+timestamp)
          console.log(date)
            return date;
        })
        function add0(m){return m<10?'0'+m:m }
        function format(shijianchuo){
            //shijianchuo是整数，否则要parseInt转换,转化为北京时间必须要*1000
            var time = new Date(shijianchuo*1000);
            var y = time.getFullYear();
            var m = time.getMonth()+1;
            var d = time.getDate();
            var h = time.getHours();
            var mm = time.getMinutes();
            var s = time.getSeconds();
            return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
        }


        /**
         * 审核状态转化
         *
         */
        Vue.filter('auditStatus',function(data){
            switch (String(data)) {
                case '0':
                    data='审核通过'
                    break;
                case '1':
                    data='审核驳回'
                    break;
                case '2':
                    data='审核中'
                    break;
                case '3':
                    data='撤回审核'
                    break;
                case '4':
                    data='发布成功'
                    break;

                default:
                    break;
            }
            return data;
        })
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js